"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[419],{

/***/ 99790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Checkbox(param) {
    var value = param.value, setValue = param.setValue, _name = param.name, name = _name === void 0 ? 'checkbox' : _name, _label = param.label, label = _label === void 0 ? '' : _label, _description = param.description, description = _description === void 0 ? '' : _description;
    var set = function(v) {
        ;
        setValue(v);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative flex items-start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    id: "data-input-".concat(name),
                    "aria-describedby": "comments-description",
                    name: name,
                    type: "checkbox",
                    onChange: function(e) {
                        return set(e.target.checked + 0);
                    },
                    defaultChecked: value === true || value === 1 || value === '1' || value === 'true',
                    className: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "ml-3",
                style: {
                    fontSize: '.95rem'
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                        htmlFor: "data-input-".concat(name),
                        className: "font-semimedium text-gray-700 cursor-pointer",
                        children: label
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        id: "data-desc-".concat(name),
                        className: "text-gray-500",
                        children: description
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 78696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchFormRegion; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var underscore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3589);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var lib_connect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43424);
/* harmony import */ var components_globals_input_wrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75565);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1852);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _app_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48387);
/* harmony import */ var _public_assets_icons_anker_port_svg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20614);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41125);
/* harmony import */ var _tailwind_config__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_tailwind_config__WEBPACK_IMPORTED_MODULE_8__);










function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function SearchFormRegion(param) {
    var setValue = param.setValue, setCountry = param.setCountry, setRegion = param.setRegion, setLocationId = param.setLocationId, errors = param.errors, interacted = param.interacted, sd1 = param.sd, country = param.country, region = param.region, locationId = param.locationId, reInitialize = param.reInitialize, _onNext = param.onNext, onNext = _onNext === void 0 ? function setValue() {} : _onNext, _basements = param.basements, basements = _basements === void 0 ? null : _basements;
    var ref5;
    var input = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), opened = ref1[0], setOpened = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), navigation = ref2[0], setNavigation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showSearchResults = ref3[0], setShowSearchResults = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), results = ref4[0], setResults = ref4[1];
    var isScreenMdOrLarger = (0,react_responsive__WEBPACK_IMPORTED_MODULE_9__.useMediaQuery)({
        query: "(min-width: ".concat((_tailwind_config__WEBPACK_IMPORTED_MODULE_8___default().theme.screens.md), ")")
    });
    var rows = isScreenMdOrLarger ? [
        1,
        2,
        3
    ] : [
        1,
        2
    ];
    var countries = function() {
        return navigation.filter(function(i) {
            return i.type === 'country';
        });
    };
    var regions = function() {
        return navigation.filter(function(i) {
            return i.type === 'region' && i.country_id === (country === null || country === void 0 ? void 0 : country.id);
        });
    };
    var locations = function() {
        return navigation.filter(function(i) {
            return i.type === 'location' && i.region_id === (region === null || region === void 0 ? void 0 : region.id);
        });
    };
    var currentCountry = function() {
        return countries().find(function(i) {
            return (i === null || i === void 0 ? void 0 : i.id) === (country === null || country === void 0 ? void 0 : country.id);
        });
    };
    var itemListCol = function(what, index) {
        var x = [];
        if (what === 'countries') x = countries();
        if (what === 'locations') x = locations();
        if (what === 'regions') x = regions();
        var counter = Math.ceil(x.length / 3);
        var start = counter * (index - 1);
        var end = Math.abs(counter * index);
        if (what === 'countries') return x.slice(start, end);
        if (what === 'locations') return x.slice(start, end);
        if (what === 'regions') return x.slice(start, end);
        return [];
    };
    var next = function() {
        setOpened(false);
        setTimeout(function() {
            onNext();
        }, 10);
    };
    var itemActive = function(type, item) {
        switch(type){
            case 'country':
                return item.id === (country === null || country === void 0 ? void 0 : country.id);
            case 'region':
                return item.id === (region === null || region === void 0 ? void 0 : region.id);
            case 'locaton':
                return item.id === locationId;
            default:
                return false;
        }
    };
    var setItem = function(type, item) {
        setValue(item.name || '');
        input.current.value = (item === null || item === void 0 ? void 0 : item.name) !== undefined ? item.name : '';
        if (type === 'country') {
            setCountry(item);
        }
        if (type === 'region') {
            setCountry(countries().find(function(i) {
                return i.id === item.country_id;
            }));
            setRegion(item);
        }
        if (type === 'location') {
            setCountry(countries().find(function(i) {
                return i.id === item.country_id;
            }));
            setRegion(countries().find(function(i) {
                return i.id === item.region_id;
            }));
            setLocationId(item.id);
        }
        if (type === 'region' && item !== '') {
            next();
        }
    };
    var toggle = function() {
        if (!opened) {
            input.current.setSelectionRange(0, sd1.length || 0);
        }
        if (window.innerWidth < 800) {
            setOpened(!opened);
        } else {
            setOpened(true);
        }
        interacted === null || interacted === void 0 ? void 0 : interacted();
    };
    var hide = function() {
        setOpened(false);
        if (sd1 === '') {
            setShowSearchResults(false);
        }
    };
    var setSearchResultItem = function(i) {
        setValue(i.name || '');
        setItem(i.type, i);
        setShowSearchResults(false);
        next();
    };
    var setFirstOnEnter = function() {
        setTimeout(function() {
            if (results.length) {
                setSearchResultItem(results[0]);
            }
        }, 50);
    };
    var search = (0,underscore__WEBPACK_IMPORTED_MODULE_2__/* .throttle */ .P2)(function(e) {
        if (e.key === 'Enter') {
            setFirstOnEnter();
            return;
        }
        var r = {};
        var sd = e.target.value;
        if (sd.length === 0) {
            setShowSearchResults(false);
            setCountry('');
            setRegion('');
            setLocationId('');
            return;
        }
        setValue(sd);
        setShowSearchResults(true);
        if (basements === null) {
            navigation.forEach(function(item) {
                var k = "".concat(item.country_id).concat(item.id).concat(item.region_id);
                item.synonyms.forEach(function(s) {
                    if (s.toLowerCase().indexOf(sd.toLowerCase()) !== -1) {
                        r[k] = item;
                    }
                });
            });
        } else {
            navigation.forEach(function(item) {
                var k = "".concat(item.country_id).concat(item.id).concat(item.region_id);
                if (item.name.toLowerCase().indexOf(sd.toLowerCase()) !== -1) {
                    r[k] = item;
                }
            });
        }
        setResults(Object.values(r));
    }, 300);
    var getModel = function() {
        var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data, result;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = [];
                        if (!(basements === null)) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 4;
                        return (0,lib_connect__WEBPACK_IMPORTED_MODULE_4__/* .fetchAPI */ .Io)("/navigation?channel=".concat(_app_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].channel */ .Z.channel, "&geojson="));
                    case 4:
                        result = _ctx.sent;
                        data = result.data;
                        _ctx.next = 9;
                        break;
                    case 8:
                        {
                            basements.forEach(function(i) {
                                var ref;
                                if ((i === null || i === void 0 ? void 0 : (ref = i.region) === null || ref === void 0 ? void 0 : ref.region) && (i === null || i === void 0 ? void 0 : i.region)) {
                                    var indexCountry = data.findIndex(function(t) {
                                        return t.type === 'country' && t.id === i.region.region.id;
                                    });
                                    if (indexCountry === -1) {
                                        data.push({
                                            type: 'country',
                                            id: i.region.region.id,
                                            name: i.region.region.name,
                                            slug: i.region.region.slug,
                                            country_id: i.region.region.id,
                                            region_id: null,
                                            location_id: null
                                        });
                                    }
                                    var indexRegion = data.findIndex(function(t) {
                                        return t.type === 'region' && t.id === i.region.id;
                                    });
                                    if (indexRegion === -1) {
                                        data.push({
                                            type: 'region',
                                            id: i.region.id,
                                            name: i.region.name.replace(", ".concat(i.region.region.name), ''),
                                            country_id: i.region.region.id,
                                            region_id: i.region.id,
                                            location_id: null
                                        });
                                    }
                                    if (data.findIndex(function(t) {
                                        return t.id === i.location.id;
                                    }) === -1) {
                                        data.push({
                                            type: 'location',
                                            id: i.location.id,
                                            name: i.location.name,
                                            country_id: i.region.region.id,
                                            region_id: i.region.id,
                                            location_id: i.location.id
                                        });
                                    }
                                }
                            });
                        }
                    case 9:
                        // eslint-disable-next-line no-nested-ternary
                        data.sort(function(a, b) {
                            return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
                        });
                        setNavigation(data);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getModel() {
            return _ref.apply(this, arguments);
        };
    }();
    var setInitialValues = function() {
        input.current.value = sd1;
        if (country !== null && country !== undefined) {
            var countryObj = countries().find(function(i) {
                return i.id === Number(country.id);
            });
            if (countryObj !== undefined) {
                setCountry(countryObj);
                input.current.value = countryObj.name;
            }
        }
        if (region !== null && region !== undefined) {
            var regionObj = navigation.find(function(i) {
                return i.id === Number(region.id);
            });
            if (regionObj !== undefined) {
                setRegion(regionObj);
                input.current.value = regionObj.name;
            }
        }
        if (locationId !== null && locationId !== undefined) {
            var locationObj = navigation.find(function(i) {
                return i.id === Number(locationId);
            });
            if (locationObj !== undefined) {
                setLocationId(locationObj.id);
                input.current.value = locationObj.name;
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setInitialValues();
    }, [
        reInitialize
    ]);
    // eslint-disable-next-line no-nested-ternary
    var transType = function(item) {
        return item.type === 'country' ? 'Land' : item.type === 'region' ? 'Region' : 'Ort';
    };
    var resetSearch = function() {
        setShowSearchResults(false);
        setValue('');
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(_asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return getModel();
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        setInitialValues();
    }, [
        navigation
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_globals_input_wrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_public_assets_icons_anker_port_svg__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "absolute z-10 w-5 h-6 pointer-events-none fill-action top-3 left-2"
        }),
        errorMessage: errors === null || errors === void 0 ? void 0 : (ref5 = errors.country) === null || ref5 === void 0 ? void 0 : ref5.message,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "relative",
            children: [
                opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "transition-all fixed inset-0 z-10 bg-black bg-opacity-0",
                    onClick: hide
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                    ref: input,
                    defaultValue: "".concat(sd1),
                    autoComplete: "off",
                    placeholder: "Fahrgebiet w\xe4hlen oder Suchbegriff eingeben",
                    onClick: toggle,
                    onKeyUp: search,
                    className: "w-full pl-10 py-3 pr-5 truncate bg-white border-gray-100 border text-left outline-0 ring-0 drop-shadow-none focus:border-primary focus:outline-0 focus:drop-shadow-none focus:ring-0",
                    "data-cy": "input-region"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "absolute left-0 bg-white shadow rounded-b rounded-tr top-full z-20  ".concat(opened ? '' : 'hidden', " ").concat(isScreenMdOrLarger ? 'w-[700px] ' : 'max-w-full'),
                    children: !showSearchResults ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "p-2",
                        "data-cy": "region-select-overlay",
                        children: [
                            locationId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "d-flex align-items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "h5 p-1",
                                            children: "Gew\xe4hlter Ort"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "d-block px-2 py-1 m-1 bg-secondary",
                                        onClick: next,
                                        children: sd1
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "inline-block mt-3 px-3 py-1 bg-gray-100 rounded p-1 text-sm",
                                        onClick: function() {
                                            return setItem('location', '');
                                        },
                                        children: "Zur\xfcck zu den Regionen"
                                    }),
                                    currentCountry() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                        className: "mt-3 ml-3 px-3 py-1 inline-block text-sm bg-action rounded",
                                        onClick: next,
                                        children: [
                                            "In",
                                            ' ',
                                            sd1,
                                            ' ',
                                            "suchen"
                                        ]
                                    })
                                ]
                            }),
                            !locationId && country && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "d-flex align-items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "h5 p-1",
                                            children: "L\xe4nder, Regionen & Fahrgebiete"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "grid sm:grid-cols-2 md:grid-cols-3",
                                        children: rows.map(function(i) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                children: itemListCol('regions', i).map(function(item, k) {
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                        className: "".concat(itemActive('region', item) ? 'bg-action' : 'bg-gray-100', " block px-2 py-1 m-1 rounded"),
                                                        onClick: function() {
                                                            return setItem('region', item);
                                                        },
                                                        children: item.name
                                                    }, k);
                                                })
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "inline-block mt-3 px-3 py-1 bg-gray-100 rounded p-1 text-sm",
                                        onClick: function() {
                                            input.current.value = '';
                                            setValue('');
                                            setCountry(null);
                                            setRegion(null);
                                            setLocationId('');
                                        },
                                        children: "Zur\xfcck"
                                    }),
                                    currentCountry() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                        className: "mt-3 ml-3 px-3 py-1 inline-block text-sm bg-action rounded",
                                        onClick: next,
                                        children: [
                                            "In",
                                            ' ',
                                            (region === null || region === void 0 ? void 0 : region.name) || country.name,
                                            ' ',
                                            "suchen"
                                        ]
                                    })
                                ]
                            }),
                            !locationId && !country && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "d-flex align-items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "h5 p-1",
                                            children: "L\xe4nder, Regionen & Fahrgebiete"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "grid sm:grid-cols-2 md:grid-cols-3",
                                        children: rows.map(function(i) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                children: itemListCol('countries', i).map(function(item) {
                                                    // eslint-disable-next-line react/jsx-no-useless-fragment
                                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: !_app_config__WEBPACK_IMPORTED_MODULE_6__/* ["default"].regionIdsToHide.includes */ .Z.regionIdsToHide.includes(item.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                            className: "".concat(itemActive('country', item) ? 'bg-action' : 'bg-gray-100', " block px-2 py-1 m-1 rounded"),
                                                            onClick: function() {
                                                                return setItem('country', item);
                                                            },
                                                            children: item.name
                                                        }, "country-".concat(item.id))
                                                    });
                                                })
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "inline-block mt-3 px-3 py-1 bg-action rounded p-1 text-sm",
                                        href: "#",
                                        onClick: next,
                                        children: "Liste ausblenden"
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "p-2",
                        "data-cy": "region-search-overlay",
                        children: [
                            sd1.length < 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: "Bitte geben Sie mindestens 3 Zeichen ein."
                            }),
                            sd1.length >= 3 && results.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: "grid sm:grid-cols-2 md:grid-cols-3",
                                children: results.map(function(i) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                            className: "block px-2 py-1 m-1 bg-gray-100 rounded",
                                            onClick: function() {
                                                return setSearchResultItem(i);
                                            },
                                            children: [
                                                i.name,
                                                ' ',
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                                    className: "rounded-full text-sm bg-action-50 px-2 ml-2 ",
                                                    children: transType(i)
                                                })
                                            ]
                                        })
                                    }, i.type + i.id);
                                })
                            }),
                            sd1.length >= 3 && !results.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                    children: "keine Ergebnisse gefunden"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                className: "inline-block mt-3 px-3 py-1 bg-action rounded p-1 text-sm",
                                onClick: resetSearch,
                                children: "Suche zur\xfccksetzen"
                            })
                        ]
                    })
                })
            ]
        })
    }));
};


/***/ })

}]);